import manageSchema from '../model/schema';
import { assertOk, takeData } from '../../misc/api-utils';
import { authFactory } from '../model/factory';

export const schema = manageSchema
  .pick({
    instance: true,
    eventShort: true,
    mevHubApi: true,
    barcode: true,
  })
  .required();

const urlFactory = ({ mevHubApi }) => new URL(mevHubApi);
const pathnameFactory = ({ instance, eventShort }) => `/${instance}/${eventShort}/auth/otp/request`;

export const fetchPut = (params) => async () => {
  const paramsParsed = schema.parse(params);

  const url = urlFactory(paramsParsed);
  url.pathname = pathnameFactory(paramsParsed);

  const headers = {
    'Content-Type': 'application/json',
    Authorization: authFactory(paramsParsed)
  };

  const body = JSON.stringify({ barcode: paramsParsed.barcode });

  const req = new Request(url, { method: 'POST', headers, body });

  return fetch(req).then(assertOk).then(takeData);
};
